const Service = () => (
    <section id="service" className="service">
        <div className="container">
            <div className="service-content">
                <div className="row">
                    <div className="col-md-4 col-sm-6">
                        <div className="single-service-item">
                            <div className="single-service-icon">
                                <i className="flaticon-car"></i>
                            </div>
                            <h2><a href="#a">largest dealership <span> of</span> car</a></h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.   
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="single-service-item">
                            <div className="single-service-icon">
                                <i className="flaticon-car-repair"></i>
                            </div>
                            <h2><a href="#b">unlimited repair warrenty</a></h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.   
                            </p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                        <div className="single-service-item">
                            <div className="single-service-icon">
                                <i className="flaticon-car-1"></i>
                            </div>
                            <h2><a href="#c">insurence support</a></h2>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Service;